import { useRef, useState } from "react"
import axios from "axios"
import { auth } from "../../../firebase"

import GLOBAL from "../../../config/variable"

import { useUserContext } from "../../../context/usercontext"

//PrimeReact
import { Button } from "primereact/button"
import { Toast } from "primereact/toast"
import { Dialog } from "primereact/dialog"

function PointItem(props) {
  const {
    productImage,
    productName,
    productPoints,
    description,
    id,
    userPoints,
    redeemable,
  } = props

  const parsedProductPoints = productPoints.toLocaleString("en-US")

  const [isSelected, setIsSelected] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  const { user, refetchUserData } = useUserContext()

  const toast = useRef(null)

  const [isRequestingInfo, setIsRequestingInfo] = useState(false)
  const [isRedeeming, setIsRedeeming] = useState(false)

  const handleRedeem = async () => {
    setIsRedeeming(true)
    try {
      await axios.post(
        `${GLOBAL.SERVER_URL}/rewards/${id}/redeem`,
        {
          userId: user.uid,
        },
        {
          headers: {
            Authorization: `Bearer ${user.accessToken}`,
          },
        }
      )
      await refetchUserData()

      setShowConfirmDialog(false)
      setIsSelected(false)
      setIsRedeeming(false)

      // Push successful redeem event to dataLayer
      window.dataLayer.push({
        event: "reward_redeemed",
        reward_name: productName,
        reward_points: productPoints,
        user_id: user.uid,
      })

      toast.current.show({
        severity: "success",
        summary: "Éxito",
        detail: "Puntos canjeados correctamente",
        position: "top-center",
        life: 5000,
      })
    } catch (error) {
      setIsRedeeming(false)
      if (error.response && error.response.status === 401) {
        // Redirigir al login si la respuesta es 401
        auth.signOut()
      }
      console.error("Error al canjear:", error)

      let errorMessage =
        "No se pudo completar el canje. Por favor, inténtelo de nuevo más tarde."

      if (error.response) {
        // El servidor respondió con un estado de error
        switch (error.response.status) {
          case 400:
            if (
              error.response.data.message ===
              "You need at least 1500 points to redeem rewards"
            ) {
              errorMessage =
                "Necesitas al menos 1500 puntos para canjear premios"
            } else {
              errorMessage =
                "No tiene suficientes puntos para realizar este canje."
            }

            break
          case 401:
            errorMessage =
              "Su sesión ha expirado. Por favor, vuelva a iniciar sesión."
            break
          case 403:
            errorMessage = "No tiene permisos para realizar este canje."
            break
          case 404:
            errorMessage = "El producto no está disponible en este momento."
            break
          case 409:
            errorMessage = "Este producto ya no está disponible."
            break
          case 500:
            errorMessage =
              "Estamos teniendo problemas técnicos. Por favor, inténtelo más tarde."
            break
          default:
            errorMessage =
              "Ha ocurrido un error inesperado. Por favor, inténtelo más tarde."
        }
      } else if (error.request) {
        // La petición fue hecha pero no se recibió respuesta
        errorMessage =
          "No se pudo conectar con el servidor. Por favor, verifique su conexión a internet."
      }

      // Push redeem error event to dataLayer
      window.dataLayer.push({
        event: "reward_redeemed_error",
        error_message: errorMessage,
        user_id: user.uid,
      })

      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
        position: "top-center",
        life: 5000,
      })
    }
  }

  const handleNotRedeemable = async () => {
    setIsRequestingInfo(true)
    try {
      await axios.post(
        `${GLOBAL.SERVER_URL}/rewards/${id}/request`,
        {
          userId: user.uid,
        },
        {
          headers: {
            Authorization: `Bearer ${user.accessToken}`,
          },
        }
      )
      // Push reward click event to dataLayer
      window.dataLayer.push({
        event: "reward_request_info",
        reward_name: productName,
        reward_points: productPoints,
        user_id: user.uid,
      })
      // Push reward request info event to dataLayer
      toast.current.show({
        severity: "success",
        summary: "Solicitud enviada",
        detail: "Se ha enviado la solicitud de información",
        position: "top-center",
        life: 5000,
      })
      setIsRequestingInfo(false)
      setIsSelected(false)
    } catch (error) {
      // Push reward request info error event to dataLayer
      window.dataLayer.push({
        event: "reward_request_info_error",
        error_message: "No se pudo enviar la solicitud de información",
        user_id: user.uid,
      })
      toast.current.show({
        severity: "error",
        summary: "Error al enviar la solicitud",
        detail:
          "No se pudo enviar la solicitud de información favor intente más tarde",
        position: "top-center",
        life: 5000,
      })
      setIsRequestingInfo(false)
    }
  }

  const confirmDialogFooter = (
    <div className="flex flex-column gap-2 ">
      <Button
        label="Sí"
        icon="pi pi-check"
        onClick={handleRedeem}
        autoFocus
        severity="secondary"
        loading={isRedeeming}
        disabled={isRedeeming}
      />
      <Button
        label="No"
        icon="pi pi-times"
        onClick={() => setShowConfirmDialog(false)}
        severity="info"
        disabled={isRedeeming}
      />
    </div>
  )

  return (
    <div className="col-12 md:col-6 lg:col-4 relative">
      <Toast ref={toast} position="top-center" life={5000} />

      <Dialog
        visible={showConfirmDialog}
        onHide={() => setShowConfirmDialog(false)}
        header="Confirma tu canje"
        footer={confirmDialogFooter}
        breakpoints={{ "1200px": "50vw", "641px": "90vw" }}
        style={{ width: "90vw", maxWidth: "500px" }}
      >
        <div className="confirmation-content">
          <i className="pi pi-sparkles mr-1" />
          ¿Estás seguro que deseas adquirir <strong>{productName}</strong> por
          un valor de <strong>{parsedProductPoints}</strong> puntos?{" "}
        </div>
      </Dialog>

      <div
        className="point-item border-round-right shadow-2"
        onClick={() => {
          setIsSelected(!isSelected)
          if (!isSelected) {
            // Push reward selected event to dataLayer
            window.dataLayer.push({
              event: "reward_selected",
              reward_name: productName,
              reward_points: productPoints,
              user_id: user.uid,
            })
          }
        }}
      >
        <div className="product-image">
          <img src={productImage} alt="Product" className="image-square" />
        </div>

        <div className="flex flex-column p-2 max-w-full">
          <div className="text-xl font-semibold text-black-alpha-60">
            <i className="pi pi-star-fill mr-1" />
            {parsedProductPoints} puntos
          </div>
          <div className="text-sm text-black-alpha-70 line-height-2">
            {productName}
          </div>
        </div>
      </div>

      {isSelected && (
        <div className="point-item-selected text-center text-base font-medium">
          <div className="text-lg line-height-2">{description}</div>
          {redeemable ? (
            <Button
              label={
                userPoints < productPoints
                  ? `Necesitas ${parsedProductPoints} puntos`
                  : "Canjear"
              }
              severity="secondary"
              icon="pi pi-gift"
              onClick={() => {
                // Push reward click event to dataLayer
                window.dataLayer.push({
                  event: "reward_click",
                  reward_name: productName,
                  reward_points: productPoints,
                  user_id: user.uid,
                })
                setShowConfirmDialog(true)
              }}
              className="my-3"
              disabled={userPoints < productPoints || isRedeeming}
            />
          ) : (
            <Button
              label={
                isRequestingInfo
                  ? "Enviando solicitud..."
                  : "Solicitar información"
              }
              severity="secondary"
              icon="pi pi-info-circle"
              className="my-3"
              onClick={handleNotRedeemable}
              loading={isRequestingInfo}
              disabled={isRequestingInfo}
            />
          )}
          <div className="flex justify-content-center align-items-center">
            <button
              style={{ background: "none", border: "none", cursor: "pointer" }}
              className="flex align-items-center justify-content-center"
              onClick={() => setIsSelected(!isSelected)}
            >
              <i className="pi pi-times" /> CERRAR
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default PointItem
